import { createSlice } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "./LoaderSlice";
import {
  login,
  changePassword,
  tokenValidate,
  passwordSet,
  forgotPassword,
} from "../../services";
import { showMessage } from "../../helpers";
import { api } from "../api/apiSlice";

const initialState = {
  isUserLoggedIn: false,
  changePasswordSuccess: false,
  validateTokenSuccess: false,
  setPasswordSuccess: false,
  isMailSend: false,
};

const userAuthenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    loginSuccess: (state) => {
      state.isUserLoggedIn = true;
    },
    loginFailure: (state) => {
      state.isUserLoggedIn = false;
    },
    logoutSuccess: (state) => {
      state.isUserLoggedIn = false;
    },
    changePasswordRequest: (state) => {
      state.changePasswordSuccess = false;
    },
    changePasswordSuccess: (state) => {
      state.changePasswordSuccess = true;
    },
    changePasswordFailure: (state) => {
      state.changePasswordSuccess = false;
    },
    validateTokenRequest: (state) => {
      state.validateTokenSuccess = false;
    },
    validateTokenSuccess: (state) => {
      state.validateTokenSuccess = true;
    },
    validateTokenFailure: (state) => {
      state.validateTokenSuccess = false;
    },
    setPasswordRequest: (state) => {
      state.setPasswordSuccess = false;
    },
    setPasswordSuccess: (state) => {
      state.setPasswordSuccess = true;
    },
    setPasswordFailure: (state) => {
      state.setPasswordSuccess = false;
    },
    forgotPasswordRequest: (state) => {
      state.isMailSend = false;
    },
    forgotPasswordSuccess: (state) => {
      state.isMailSend = true;
    },
    forgotPasswordFailure: (state) => {
      state.isMailSend = false;
    },
  },
});

// Export actions
export const {
  loginSuccess,
  loginFailure,
  logoutSuccess,
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailure,
  validateTokenRequest,
  validateTokenSuccess,
  validateTokenFailure,
  setPasswordRequest,
  setPasswordSuccess,
  setPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} = userAuthenticationSlice.actions;

// Thunks
export const userLogin = (data, onSuccess) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await login(data);
    dispatch(hideLoader());
    if (!response) {
      showMessage("error", "User Does not exist");
      dispatch(loginFailure());
    } else {
      dispatch(loginSuccess());
      localStorage.setItem("user", JSON.stringify(response));
      showMessage("success", "User logged in successfully");
      if (onSuccess) {
        onSuccess();
      }
    }
  } catch (error) {
    dispatch(hideLoader());
    dispatch(loginFailure());
    console.log(error);
  }
};

export const userLogout = () => (dispatch) => {
  // Clear RTK Query cache before logout
  dispatch(api.util.resetApiState());
  dispatch(logoutSuccess());
  localStorage.removeItem("user");
};

export const userChangePassword = (data) => async (dispatch) => {
  dispatch(showLoader());
  dispatch(changePasswordRequest());
  try {
    await changePassword(data);
    dispatch(hideLoader());
    dispatch(changePasswordSuccess());
    showMessage("success", "Password changed successfully");
  } catch (error) {
    dispatch(hideLoader());
    dispatch(changePasswordFailure());
    showMessage("error", error.toString());
  }
};

export const resetChangePassword = () => (dispatch) => {
  dispatch(changePasswordRequest());
};

export const validateToken = (data) => async (dispatch) => {
  dispatch(showLoader());
  dispatch(validateTokenRequest());
  try {
    await tokenValidate(data);
    dispatch(hideLoader());
    dispatch(validateTokenSuccess());
  } catch (error) {
    dispatch(hideLoader());
    dispatch(validateTokenFailure());
    console.log(error);
    showMessage("error", error.toString());
  }
};

export const setPassword = (data, onSuccess) => async (dispatch) => {
  dispatch(showLoader());
  dispatch(setPasswordRequest());
  try {
    await passwordSet(data);
    dispatch(hideLoader());
    dispatch(setPasswordSuccess());
    showMessage("success", "Password set successfully");
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    dispatch(hideLoader());
    dispatch(setPasswordFailure());
    showMessage("error", error["password"][0]);
  }
};

export const userForgetPassword = (data) => async (dispatch) => {
  dispatch(showLoader());
  dispatch(forgotPasswordRequest());
  try {
    await forgotPassword(data);
    dispatch(hideLoader());
    dispatch(forgotPasswordSuccess());
    showMessage(
      "success",
      "Email to change password has been sent to given email id!",
    );
  } catch (error) {
    dispatch(hideLoader());
    dispatch(forgotPasswordFailure());
    if (error && error.email) {
      showMessage("error", error.email[0]);
    }
  }
};

export default userAuthenticationSlice.reducer;
